import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import {array} from 'prop-types';
import React from 'react';

const RelatedLinks = ({links = []}) => {
  const related = links.filter(link => link.rel === 'related');
  if (related.length === 0) {
    return null;
  }
  return (
    <Box
      sx={{
        marginY: 2,
      }}
    >
      <Typography>Related Links</Typography>
      <ul>
        {related.map(link => (
          <li key={link.href}>
            <Link href={link.href} target="_blank" rel="noopener noreferrer">
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </Box>
  );
};

RelatedLinks.propTypes = {
  links: array.isRequired,
};

export default RelatedLinks;
